import React from 'react';

import type {ArtifactVersionMetricPlotReady} from './artifactVersionMetricPlotModel';
import {ArtifactVersionMetricXYPlotFrame} from './ArtifactVersionMetricXYPlotFrame';

type ArtifactVersionMetricLineChartProps = {
  plot: ArtifactVersionMetricPlotReady;
  width: number;
  height: number;
};

export const ArtifactVersionMetricLineChart: React.FC<
  ArtifactVersionMetricLineChartProps
> = ({plot, width, height}) => (
  <ArtifactVersionMetricXYPlotFrame
    plot={plot}
    width={width}
    height={height}
    connectPoints
  />
);
